// export const API_URL = "http://104.131.7.59:8000/api/v1";
export const API_URL = "http://181.188.137.123:8080/api/v1";
// export const API_URL = "http://ccead_backend.test/api/v1";
export default API_URL;
